import styled, { css } from 'styled-components'

const v4 = css`
  #more-help {
    h2 {
      font-size: var(--h1);
      text-transform: inherit;
      color: var(--clr-accent-to-white);
    }
    button {
      font-weight: normal;
    }
  }
`
export const Wrapper = styled.div`
  #more-help {
    margin: ${props => (props.showDefaultAd ? `4rem` : `7rem`)} 0 2rem 0;
    padding: 0 10px;
    text-align: center;
    color: var(--clr-home-text-to-white);
    h2 {
      font-weight: 700;
      font-size: var(--h4);
      text-transform: capitalize;
    }
    .line {
      border-bottom-style: solid;
      border-bottom-width: 1px;
      width: fit-content;
    }
    p {
      font-size: var(--h5);
      color: var(--clr-home-text-to-text);
    }
    button {
      margin-top: 20px;
      border: none;
      color: var(--clr-home-text-to-white);
      background-color: transparent;
      font-weight: bold;
      font-size: var(--h5);
    }

    button:hover {
      filter: brightness(0.4);
    }
  }
  ${props => props.version === 'v4' && v4}
`



// WEBPACK FOOTER //
// ./src/components/MoreHelpFooter/styles.js